export default "__VITE_ASSET__24b23e11__"